import company1 from "../assets/companies/image-01.png";
import company2 from "../assets/companies/image-02.png";
import company3 from "../assets/companies/image-03.png";
import company4 from "../assets/companies/image-04.png";
import company5 from "../assets/companies/image-05.png";
import company6 from "../assets/companies/image-06.png";
import company7 from "../assets/companies/image-07.png";
import company8 from "../assets/companies/image-08.png";
import company9 from "../assets/companies/image-09.png";
import company10 from "../assets/companies/image-10.png";

export const companies = [
    {
        title: "Amazon",
        logo: company10
    },
    {
        title: "Nasa",
        logo: company9
    },
    {
        title: "Sony",
        logo: company8
    },
    {
        title: "Samsung",
        logo: company7
    },
    {
        title: "Coca-cola",
        logo: company6
    },
    {
        title: "Google",
        logo: company5
    },
    {
        title: "Nike",
        logo: company4
    },
    {
        title: "Microsoft",
        logo: company1
    },
    {
        title: "SpaceX",
        logo: company3
    },
    {
        title: "Tesla",
        logo: company2
    },
];